<template>
  <div v-if="visible" class="fixed inset-0 z-40 overflow-auto">
    <div
      class="fixed inset-0 bg-black bg-opacity-75"
      @click="closeFromOverlay"
    ></div>
    <div
      class="modal-content-wraper relative mx-auto z-50 px-3 py-12"
      :class="variant === 'form' ? 'w-full lg:w-paper' : 'max-w-lg'"
      role="dialog"
      aria-modal="true"
      :aria-label="header"
    >
      <div class="overflow-visible relative rounded bg-white shadow">
        <button
          type="button"
          class="flex items-center justify-center rounded-full absolute right-0 top-0 -m-3 h-8 w-8 bg-gray-100 text-gray-600"
          aria-label="Cerrar"
          @click="close"
        >
          ×
        </button>
        <header v-if="header" class="p-3 text-2xl">{{ header }}</header>
        <div class="p-3"><slot /></div>
        <footer v-if="$slots.footer" class="p-3 bg-gray-100">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppModal",
  props: {
    modelValue: Boolean,
    value: Boolean,
    header: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "",
    },
    clickToClose: {
      type: Boolean,
      default: true,
    },
    escToClose: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue", "input", "close"],
  computed: {
    visible() {
      return this.modelValue || this.value;
    },
  },
  mounted() {
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    onKeydown(event) {
      if (event.key === "Escape" && this.escToClose) this.close();
    },
    closeFromOverlay() {
      if (this.clickToClose) this.close();
    },
    close() {
      this.$emit("update:modelValue", false);
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>
